export const OnlyEnemies: { [id: number]: string } = Object.freeze({
  0: 'N/A',
  153: 'はぐれメタル',
  163: 'ヒートギズモ',
  172: 'ダークデンデン',
  177: 'フロストギズモ',
  180: 'キャノンキング',
  181: 'ナイトリッチ',
  189: 'マポレーナ',
  191: 'レッドドラゴン',
  193: 'アカイライ',
  207: 'ゴールデントーテム',
  208: 'ラストテンツク',
  214: 'メタルキング',
  216: 'レジェンドホース',
  220: 'スライムマデュラ',
  226: 'ゴールデンスライム',
  227: 'ゴールドマジンガ',
  236: 'あんこくまじん',
  241: 'れんごくまちょう',
  244: 'アンドレアル',
  250: 'まかいファイター',
  254: 'ドラゴン・ウー'
})
